import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-lg bg-slate-200/60 dark:bg-gray-50/10",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
